import { POPUP_TEAM_BASE, SALES_PIPELINE_SEGMENT, isMobileTeamViewport, resolveSalesPipelineAppUrl } from "./teamNavigation";
import { appNavigate } from "./appNavigateBridge";
import { openWindowWithTabAuth } from "./tabAuthStorage";

/**
 * Abre o pipeline de vendas em janela popup (/popup-equipe/sales-pipeline).
 * No mobile, navega para /equipe/sales-pipeline dentro do app principal.
 */
export function openSalesPipelinePopupWindow({ leadId } = {}) {
  if (isMobileTeamViewport()) {
    appNavigate(resolveSalesPipelineAppUrl({ leadId }));
    return null;
  }

  const base = `${POPUP_TEAM_BASE}${SALES_PIPELINE_SEGMENT}`.replace(/\/+$/, "");
  const url =
    leadId != null
      ? `${base}/${encodeURIComponent(String(leadId))}`
      : base;

  const width = window.screen.availWidth || window.screen.width;
  const height = window.screen.availHeight || window.screen.height;

  return openWindowWithTabAuth(
    url,
    "SalesPipelinePopup",
    `width=${width},height=${height},top=0,left=0,scrollbars=no,toolbar=no,location=no,status=no,menubar=no`
  );
}
